/**
 * Speurtocht User Layout
 */

import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function SpeurttochtLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[id]/index" />
    </Stack>
  );
}

